<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Analytical Table KPI Scores</h1>
      <p>
        In addition to having a graphical representation in the SII & SPI Analysis, it is also possible to view the data
        in <b>an analytical table</b>. By scrolling all the way down, until the <b>Analytic SII Scores</b> section
        along with the <b>Analytic SPI Scores</b> section is reached, the user will see two tables stacked on top of each
        other that present the analysis thoroughly for each Aggregation Level. In order to keep things simplified, the
        color-coding of the tables is adjusted accordingly as it was in the rest of the analysis regarding the
        Aggregation Levels.
      </p>

      <div class="image-container">
        <img src="@/images/manual/sii-table.png" alt="sii table" />
        <div class="img-caption">
          Figure 1. The Analytical SII Scores in a table.
        </div>
      </div>

      <p>
        In the SII Score section, the table describes each KPI in an analytical manner. Every KPI belongs to a dimension,
        in which all the KPI scores are then summed up to make the Final SII Score of each dimension. This table, consists
        of seven columns. The first six come from the user's input, while the last two are from the analysis itself.
      </p>

      <div class="image-container">
        <img src="@/images/manual/sii-table-explained.png" alt="sii table explained" />
        <div class="img-caption">
          Figure 2. The SII Table's columns explained.
        </div>
      </div>

      <p>
        The SPI Scores can be found by scroll down further in the Analysis Page, which is a very similar table to the
        one mentioned above. The SPI Scores table is more compact than the SII Scores table since a lot of the information
        is already presented in the second one, thus, it consists of only three columns. The last row presents the
        Weighted Score is from the analysis.
      </p>

      <div class="image-container">
        <img src="@/images/manual/spi-scores.png" alt="spi table" />
        <div class="img-caption">
          Figure 3. The Analytical SPI Scores in a table.
        </div>
      </div>

      <p>
        To view the rest of the Aggregation Levels, the user can change the selection of the dropdowns above the tables.
        As mentioned above, the Aggregation Levels are color-coded in the table as well. When the selected aggregation level
        is changed, the entire table's colors will change to the corresponding color-coding.
      </p>

      <div class="image-container">
        <img src="@/images/manual/spi-peb-scores.png" alt="spi peb table" />
        <div class="img-caption">
          Figure 4. The Analytical SPI Scores in the PEB Level.
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
